import type { BrowserOptions } from "@sentry/react";

type TransactionEvent = Parameters<
  NonNullable<BrowserOptions["beforeSendTransaction"]>
>[0];

const NOISY_OPS = new Set([
  "resource.img",
  "resource.script",
  "resource.css",
  "resource.link",
  "resource.other"
]);

export const beforeSendTransaction = (
  event: TransactionEvent
): TransactionEvent | null => {
  const spans = (event.spans ?? []).filter(
    (s) => !(s.op && NOISY_OPS.has(s.op))
  );
  if (spans.length < 2) {
    return null;
  }
  return { ...event, spans };
};
